import script from "./terminalWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./terminalWindow.vue?vue&type=script&setup=true&lang=js"

import "./terminalWindow.vue?vue&type=style&index=0&id=7bf38f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf38f04"]])

export default __exports__